import { Link } from 'react-router-dom';

export default function CTABanner() {
  return (
    <section className="py-14 md:py-20 bg-[#1a3a4a] relative overflow-hidden">
      {/* Decorative circles */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-[#00c9a7]/5 -translate-y-1/2 translate-x-1/3" />
      <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-[#00c9a7]/5 translate-y-1/2 -translate-x-1/3" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 border border-[#00c9a7]/40 text-[#00c9a7] text-xs font-semibold px-4 py-2 rounded-full mb-5 md:mb-6">
          <i className="ri-map-pin-line" />
          Atendemos em João Pessoa e Região
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-white mb-4 md:mb-5 leading-tight">
          Seu Computador com Problema?{' '}
          <span className="text-[#00c9a7]">A Gente Resolve!</span>
        </h2>

        <p className="text-white/60 text-sm md:text-lg mb-8 md:mb-10 max-w-xl mx-auto">
          Entre em contato agora e receba um diagnóstico gratuito. Vamos até você ou resolvemos remotamente!
        </p>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
          <a
            href="https://wa.me/5583991755663?text=Olá!%20Gostaria%20de%20solicitar%20um%20atendimento%20da%20JampaBit."
            target="_blank"
            rel="nofollow noreferrer"
            className="flex items-center justify-center gap-2 bg-[#00c9a7] hover:bg-[#00b396] text-white font-semibold px-7 md:px-8 py-3.5 md:py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <i className="ri-whatsapp-line text-lg" />
            Chamar no WhatsApp
          </a>
          <Link
            to="/contato"
            className="flex items-center justify-center gap-2 bg-white/15 hover:bg-white/25 border border-white/50 hover:border-white text-white font-semibold px-7 md:px-8 py-3.5 md:py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm text-sm md:text-base"
          >
            <i className="ri-mail-send-line" />
            Enviar Mensagem
          </Link>
        </div>
      </div>
    </section>
  );
}
